module.exports = __webpack_public_path__ + "static/media/ic_deduct_credit.db64bdc9.svg";